// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__T2srV","savePackageButton":"ClientWallet_savePackageButton__3mPMc"};